module.exports = __webpack_public_path__ + "static/media/rob03.b1cbffb8.jpg";